import { GtmPlugin } from "@gtm-support/vue-gtm"
import Cookie from './cookie.util'

export const measure = (
  data: Record<string, string | number | boolean | null | undefined>,
  options?: { baseUrl?: string, gtm?: GtmPlugin }
) => {
  const id = `${Date.now()}.${(Math.random() * 10000000000000000000)}`
  if (options?.gtm?.enabled()) {
    options.gtm.trackEvent({
      event: 'interaction',
      event_id: id,
      ...data
    })
  }

  /*
  const fbConversationMap: Record<string, string> = {
    'content-view': 'PageView',
    'sign_up': 'SubscribedButtonClick',
    'form_submit': 'SubmitApplication',
    'search_submit': 'Search'
  }

  const name = fbConversationMap[String(data['event_name'])] ?? fbConversationMap[String(data['event'])]

  if (name) {
    const headers = new Headers()
    headers.append('Content-Type', 'application/json')

    fetch((options?.baseUrl ?? window.location.origin) + '/api/fb-conversion', {
      method: 'POST',
      headers,
      body: JSON.stringify({
        event_id: id,
        event_name: name,
        event_source_url: window.location.href,
        action_source: 'website',
        user_data: {
          fbc: Cookie.get('_fbc'),
          fbp: Cookie.get('_fbp'),
          client_user_agent: navigator.userAgent
        }
      })
    })
  }
  */
}
